import {
  branchesDimension,
  getCurrentBranchMode,
} from '@packages/systems/designer/branches-dimension';
import {abilityFeature} from '../abilityFeature';

export {getCurrentBranchMode};

export const branches = abilityFeature({
  key: 'branches',
  isValid: function isBranchesValid(state, config) {
    return branchesDimension.isValid(state, config);
  },
});
